import PropTypes from 'prop-types';
import React from 'react';

function HeaderListHeading(props) {
  const { text } = props;

  return (
    <h2 className="ontheshow__header-list-heading">{ text }</h2>
  );
}

HeaderListHeading.propTypes = {
  text: PropTypes.string.isRequired,
};

HeaderListHeading.defaultProps = {

};

export default HeaderListHeading;
